import Backbone from 'backbone';
import _ from 'underscore';
import Guest from './guest';

const GuestList = Backbone.Collection.extend({
  model: Guest,

  validate() {
    return _.every(this.models, (model) => !model.validate());
  },
});

module.exports = GuestList;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/guests/models/guest-list.js
 **/